import React from 'react';
import {AccountIndexPage} from '@mgp-fe/shared/modules';
import MemberZoneLayout from '@mgp-fe/customer/modules/common/ui/MemberZoneLayout.tsx';

export default function AccountPage() {
	return <MemberZoneLayout>
		<AccountIndexPage/>
	</MemberZoneLayout>;
}
